<template>
  <div class="view-register auth mb-5">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-lg-5 mx-auto">
          <h1 class="text-center mb-5">
            <img src="@/assets/logo-white.svg" />
          </h1>

          <form class="card px-lg-5 py-lg-4" @submit.prevent="submit">
            <div class="card-body">
              <steps class="mb-4" :number="2" />

              <p class="text-center lead mb-4 text-primary">
                {{ $t("seusDados") }}
              </p>

              <image-input
                class="mb-4 d-flex justify-content-center"
                @pick="pickFile"
                :url="picture"
              />

              <form-group
                v-model="first_name"
                id="first_name"
                type="text"
                :placeholder="$t('nome')"
                :errors="errors.first_name"
              />

              <form-group
                v-model="last_name"
                id="last_name"
                type="text"
                :placeholder="$t('sobrenome')"
                :errors="errors.last_name"
              />

              <form-group
                v-model="email"
                id="email"
                type="email"
                :placeholder="$t('email')"
                :errors="errors.email"
              />

              <form-group
                v-model="password"
                id="password"
                type="password"
                :placeholder="$t('senha')"
                :errors="errors.password"
              />

              <div class="text-center pt-3">
                <button
                  type="submit"
                  class="btn btn-danger rounded-pill px-3 min-height-38"
                  :disabled="loading"
                >
                  <loading :show="loading">
                    <i class="icon-check"></i>
                    {{ $t("proximo") }}
                  </loading>
                </button>
              </div>
            </div>
          </form>

          <p class="text-center my-5 text-light">
            {{ $t("jaSouCadastrado") }}
            <router-link class="text-light" :to="{ name: 'login' }">{{
              $t("queroEntrar")
            }}</router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {
      picture: null,
      terms: false,
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      loading: false,
      errors: {
        first_name: [],
        last_name: [],
        email: [],
        password: []
      }
    };
  },
  created() {
    const q = this.$route.query;
    if (q.email) this.email = q.email;
    if (q.first_name) this.first_name = q.first_name;
    if (q.last_name) this.last_name = q.last_name;
    if (q.resume === "1" && q.phone) {
      localStorage.setItem("phoneAgencyRegister", q.phone);
    }
  },
  methods: {
    pickFile(file) {
      this.picture = file;
    },
    submit() {
      this.$message.hide();

      this.loading = true;

      const data = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        password: this.password
      };
      localStorage.setItem("setStripeCustomerEmail", this.email);
      if (this.picture) {
        data.picture = this.picture;
      }

      this.$store
        .dispatch("user/register", data)
        .then(() => {
          this.$router.replace({ name: "register-2" });
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-register {
  width: 100%;
}
</style>
